import { Box, Text } from '@frontend/legacy-components';

type ViewerButtonTooltipProps = {
  firstLine: string;
  /** Optional hint line (e.g. a keyboard shortcut) below the label. */
  secondLine?: string;
};

/**
 * ViewerButtonTooltip formats one or two lines of text, for use in a Tooltip.
 * The first line is shown in bold.
 *
 * `secondLine` is optional because most tools are a bare label — several existing
 * callers already omit it, which went unnoticed only because they are untyped `.js`.
 */
export const ViewerButtonTooltip = ({
  firstLine,
  secondLine,
}: ViewerButtonTooltipProps) => (
  <Box alignItems="center" display="flex" flexDirection="column">
    <Text fontWeight="bold" textColor="feature.onInteraction">
      {firstLine}
    </Text>
    {secondLine !== undefined && (
      <Text
        fontWeight="medium"
        textAlign="center"
        textColor="feature.onInteraction"
      >
        {secondLine}
      </Text>
    )}
  </Box>
);
ViewerButtonTooltip.displayName = 'ViewerButtonTooltip';
